<script lang="ts">
	import type { ErrorPage } from '$lib/api/pages/error';
	import PrimaryButton from '$lib/buttons/primaryButton.svelte';
	import Newsletter from '$lib/newsletter/newsletter.svelte';
	import Header from '$lib/layout/header.svelte';
	import log from '$lib/utils/log';
	import FooterV2 from '$lib/layout/footerV2.svelte';
	import SanityImage from '$lib/sanityImage.svelte';
	import MillStone from '$lib/icons/millStone.svelte';
	import { fade } from 'svelte/transition';
	import { page } from '$app/state';

	async function getErrorPage(): Promise<ErrorPage> {
		const response = await fetch(`/api/cms/error/${page.status}`);

		if (!response.ok) throw new Error('Something went wrong');

		return response.json();
	}

	const errorPage = getErrorPage();

	$effect(() => {
		log.scope('Error Page').error(page.error?.message || 'Error Page', {
			status: page.status,
			route: page.route?.id || '',
			path: page.url.pathname
		});
	});
</script>

<svelte:head>
	{#await errorPage}
		<title>Mill | Error</title>
		<meta name="description" content="" />
	{:then page}
		<title>{page.seoTitle || 'Mill | Error'}</title>
		<meta name="description" content={page.seoDescription || ''} />
	{/await}
</svelte:head>

<Header />

<div class="mx-auto max-w-screen-xl" style="padding-top: var(--full-header-height)">
	{#await errorPage}
		<div class="flex min-h-screen items-center justify-center" transition:fade>
			<MillStone class="h-20 w-20 animate-[spin_3s_linear_infinite] text-brown-2" />
		</div>
	{:then page}
		<div
			class="mx-container-mobile mt-36 flex flex-col items-center lg:mx-container-desktop lg:mt-[283px]"
		>
			<SanityImage
				assetId={page.assetId}
				dimensions={{ width: 790 }}
				variants={{ 1024: { width: 1200 } }}
				alt=""
				class="mx-auto object-cover sm:w-1/2"
				width="702"
				height="304"
			/>
			<p
				class="mb-6 max-w-screen-lg text-center text-[24px] font-bold leading-[30px] text-brown-2 lg:mb-12 lg:text-[48px] lg:font-semibold lg:leading-[52.8px]"
			>
				{page.text}
			</p>
			<PrimaryButton href="/" wrapperClass="mb-[90px] lg:mb-[283px]">{page.cta}</PrimaryButton>
		</div>
	{:catch error}
		<p
			class="mb-6 max-w-screen-lg text-center text-[24px] font-bold leading-[30px] text-brown-2 lg:mb-12 lg:text-[48px] lg:font-semibold lg:leading-[52.8px]"
		>
			{error?.message || 'Something went wrong. :('}
		</p>
	{/await}
</div>

<Newsletter />
<FooterV2 />
